import Toggle from "@/ui/Toggle";
import SeccionLayout from "../SeccionLayout";
import { AYUDA_SECCION } from "@/components/ayuda/vistas/configuracion";
import { useAppSettings } from "../useAppSettings";

/**
 * Freno de mano de la revisión automática de la bandeja con IA.
 *
 * Una sola perilla, sin botón de guardar: se aplica al momento.
 */
export default function RevisionIA() {
  const { settings, cargando, alternar } = useAppSettings();

  if (cargando || !settings) {
    return <p className="text-sm text-zinc-500">Cargando…</p>;
  }

  return (
    <SeccionLayout
      ayuda={AYUDA_SECCION["revision-ia"]}
      ancho="formulario"
      titulo="Revisión de correos con IA"
      descripcion="Cuando llega un correo que no cae solo en un caso, la IA lo lee y decide si pertenece a un caso que ya existe o si hay que abrir uno nuevo, y lo deja listo en la bandeja. Si está muy segura de que es de un caso, lo asigna sola y se puede deshacer. Un caso nuevo siempre lo confirma una persona."
    >
      <div className="card space-y-2">
        <Toggle
          checked={settings.triage_ia_activo}
          onChange={(v) =>
            void alternar(
              "triage_ia_activo",
              v,
              v ? "Revisión con IA activada" : "Revisión con IA desactivada",
            )
          }
          label="Revisar la bandeja con IA"
        />
        <p className="text-[11px] text-zinc-500">
          Se aplica al momento. Apagarlo no borra nada de lo que la IA ya dejó en la bandeja.
        </p>
      </div>
    </SeccionLayout>
  );
}
